'use strict';

(function($) {

    var pluginName = 'kumsalFile';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var file = this;


        var Plugin = {
            isInit: false,
            sortable: null,
            options: {
                multiple: false,
                readonly: false,
                min: 0,
                max: 0,
                inputName: '',
            },
            maxFileCondition: function(){
                return (!file.options.multiple && file.find('.kumsal-file').length) ||
                    (file.options.multiple && file.options.max && file.find('.kumsal-file').length >= file.options.max);
            },
            calculate:function(){
                file.maxFileCondition() ?
                    file.find('.kumsal-file-create').addClass('d-none') :
                    file.find('.kumsal-file-create').removeClass('d-none');
                file.find('.kumsal-file-input').attr('name',file.options.inputName);
            },
            createFile:function(button){
                $(button).kumsalAction(Object.assign({}, $(button).data(),{
                    actionReady: function (action) {
                    },
                    actionSuccess: function (action,response) {
                        file.find('.kumsal-file-container').append(response.file);
                        file.calculate();
                        file.find('.kumsal-file-input').attr('name',file.options.inputName)
                    },
                    formData: {
                        translation:$(button).parents('.kumsal-files').data('translation'),
                        language:$(button).parents('.kumsal-files').data('language')
                    },
                }));
            },
            editFile:function(button){
                $(button).kumsalAction(Object.assign({}, $(button).data(),{
                    actionReady: function (action) {
                    },
                    actionSuccess: function (action,response) {
                        $(action).parents('.kumsal-file')[0].outerHTML = response.file;
                        file.calculate();
                    },
                    formData: {
                        translation:$(button).parents('.kumsal-files').data('translation'),
                        language:$(button).parents('.kumsal-files').data('language')
                    },
                }));
            },
            initEvents:function(){
                file.on('click','.kumsal-file-delete',function (event) {
                    event.preventDefault();
                    $(this).parents('.kumsal-file').remove();
                    file.calculate();
                });

                file.on('click','.kumsal-file-create',function (event) {
                    event.preventDefault();
                    if(!file.maxFileCondition()){
                        file.createFile(this);
                    }
                });

                file.on('click','.kumsal-file-edit',function (event) {
                    event.preventDefault();
                    file.editFile(this);
                });
            },
            initSortable:function(){
                file.sortable = Sortable.create(file.find('.kumsal-file-container')[0], {
                    handle: '.kumsal-file-drag',
                    animation: 150,
                    group: 'files',
                    onEnd: function (e) {
                        $(e.item).parents('.kumsal-files').kumsalFile().calculate()
                    },
                });
            },
            init: function() {
                file.options = file.data();

                file.options.multiple = file.options.multiple || false;
                file.options.readonly = file.options.readonly || false;
                file.options.min = file.options.min || 0;
                file.options.max = file.options.max || 0;
                file.options.inpuName = file.options.inpuName || '';

                file.initEvents();

                if (file.options.multiple){
                    file.initSortable();
                }

                file.calculate();

                return file;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            file[funcName] = func;
        });


        if (!file.isInit){
            file.init();
        }

        return file;
    };

}(jQuery));

$('document').ready(function () {

    $(".kumsal-files").each(function( index ) {

        $(this).kumsalFile();
    });
});